<template>
  <div>
    <x-grid :id="'formList'"
            :rowId="rowId"
            :pager-config="pagerConfig"
            :form-config="formConfig"
            :url="url"
            :columns="columns"
            :checkbox-config="checkboxConfig"
            :toolbar-config="toolbarConfig"
            :print-config="printConfig"
            :export-config="exportConfig"
            ref="grid"
            :cellClick="chooseRow"
            :cellDbClick="updateRow"
            @toolbar-addData="addRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
      </template>
    </x-grid>

    <!-- 详情页 -->
    <a-modal
        title="通用代码管理"
        centered
        :closable="false"
        :footer="null"
        :maskClosable="false"
        :visible="editModalVisible"
        :width="1200"
    >
      <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
      <detailForm :rowId="editRowId"
                  v-if="editModalVisible"
                  ref="detailForm"
                  @cancelled="closeEdit()"
                  @saved="closeEdit(true)">
      </detailForm>
    </a-modal>


  </div>
</template>

<script>
import XGrid from '@/components/grid/XGrid';
import {GridMixin} from "@/utils/GridMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter";
import api from '@/services/api';
import {loadBaseCodeData} from "@/services/baseCodeSource";

console.info(fmt, loadBaseCodeData);//防止未用到报未定义错误 用到了可删除

import detailForm from "@/pages/web/comm/commBaseCodeManage/commBaseCodeManageDetail";

const fac = XGrid.factory;

//列表接口
const url = api.comm.BASE_CODE;

//主键
const rowId = 'typeNo';

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumn("typeNo", "类型编号", 140),
  fac.makeColumn("typeName", "类型名称", 140),
  //fac.makeColumn("controlstateName", "控制类型", 100),
  fac.makeColumn("remark", "备注", 300,),
]


// 筛选条件
const formConfig = fac.makeFormConfig(columns, [
  {field: 'typeNo'},
  {field: 'typeName'},
  /*{
      field: 'mbrStatusName',
      type: 'select',
      options: [{
          value: '',
          label: '全部'
      }, {
          value: '正常',
          label: '正常'
      }, {
          value: '禁用',
          label: '禁用'
      }]
  },*/
])


//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  export: false,
  import: false,
  addData: false,
  delData: false,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);


export default {
  mixins: [GridMixin],
  // authorize: {
  //   addRow: "ADD",
  //   updateRow: 'UPDATE',
  //   delRow: 'DELETE',
  // },
  components: {
    detailForm,
  },
  data() {
    return {
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
    }
  },
  methods: {
    closeEdit(flag) {
      console.log(flag)
      this.editModalVisible = false
      if (flag) {
        this.refresh()
      }
    }
  }
}
</script>

<style scoped>
</style>